(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/banner-background/assets/javascripts/banner-background.js') >= 0) return;  svs.modules.push('/widgets/banner-background/assets/javascripts/banner-background.js');

'use strict';

svs.widget = svs.widget || {};
svs.widget.banner_background = svs.widget.banner_background || {};
svs.widget.banner_background.init = svs.banner_groups.banner_background.init;

 })(window);